/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Plx from 'react-plx';

import { Grid, Typography } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { createAboutUsSectionStyles } from './AboutUsSection.styles';

const parallaxData = [
  {
    start: '.plxAboutUs',
    duration: '40vh',
    properties: [
      {
        startValue: -40,
        endValue: 0,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  },
];

export const AboutUsSection = memo(() => {
  const classes = createAboutUsSectionStyles();
  const { t } = useTranslation(Namespaces.About);

  return (
    <Grid container className={classes.root}>
      <Plx className={cx('plxAboutUs', classes.plxBlock)} parallaxData={parallaxData}>
        <Grid container classes={{ root: classes.container }}>
          <Grid item md={8}>
            <Typography variant="h1" classes={{ root: cx(classes.text, classes.textTransparent) }}>
              {t('about_us.top_text')}
            </Typography>
          </Grid>
        </Grid>

        <Grid container classes={{ root: classes.container }}>
          <Grid item md={8}>
            <Typography variant="h2" classes={{ root: classes.text }}>
              {t('about_us.bottom_text')}
            </Typography>
          </Grid>
          <Grid item md={4} classes={{ root: classes.gridFlex }}>
            <Trans>
              <Typography variant="h2" classes={{ root: cx(classes.text, classes.textHighlighted) }}>
                {t('about_us.we_are_here_for_you')}
              </Typography>
            </Trans>
          </Grid>
        </Grid>
      </Plx>
    </Grid>
  );
});
